export const ANALYTICS_TEXT = {
  title: 'Analytics Cookies',
  description:
    'These cookies allow us to count visits and traffic sources, so we can measure and improve the performance of our site.',
};
